import { skipToken } from '@reduxjs/toolkit/query'
import { ROUTE_PATHS } from 'core/constants/routePath'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import {
  useUpdatePromptMultipartMutation,
  useDeletePromptMutation,
  useGetPromptQuery,
} from 'lauria/api/prompt'
import { useGetAllPromptHistorisesQuery } from 'lauria/api/promptHistorise'
import { promptLayout } from 'lauria/store/slices/promptLayout'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router'

export const usePromptContent = (
  promptId: number | null,
  refetchPrompts: () => {}
) => {
  const {
    data: prompt,
    isLoading: isLoadingPrompt,
    isFetching: isFetchingPrompt,
    refetch: refetchPrompt,
  } = useGetPromptQuery(promptId ? { promptId } : skipToken)
  const [openRemoveModal, setOpenRemoveModal] = useState(false)
  const [openHistoryModal, setOpenHistoryModal] = useState(false)
  const [openRetrieveHistoryModal, setOpenRetrieveHistoryModal] =
    useState(false)
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false)
  const [promptHistory, setPromptHistory] = useState<IPromptHistory | null>(
    null
  )

  const {
    data: promptHistorises,
    isLoading: isLoadingPromptHistorises,
    refetch: refetchPromptHistorises,
  } = useGetAllPromptHistorisesQuery(
    { promptId: promptId ?? 0 },
    { skip: !openHistoryModal || promptId == null }
  )

  useEffect(() => {
    if (openHistoryModal) refetchPromptHistorises()
  }, [openHistoryModal, refetchPromptHistorises])

  const [deletePrompt, { isLoading: isDeleting }] = useDeletePromptMutation()
  const navigate = useNavigate()
  const { application } = useSelector(promptLayout)
  const [updatePromptMultipart, { isLoading: isUpdating }] =
    useUpdatePromptMultipartMutation()
  const changeStatus = () => {
    if (prompt) {
      const formData = new FormData()
      formData.append('actif', !prompt.actif ? 'true' : 'false')
      updatePromptMultipart({ promptId: prompt.id, data: formData })
        .unwrap()
        .then(() => {
          refetchPrompt()
          refetchPrompts()
          setOpenChangeStatusModal(false)
        })
    }
  }
  const handleAppClick = () => {
    navigate(
      generatePath(ROUTE_PATHS.PROMPT_EDIT, {
        idApplication: application?.id,
        idPrompt: prompt?.id,
      })
    )
  }

  const handleDelete = () => {
    if (prompt) {
      deletePrompt(prompt.id)
        .unwrap()
        .then(() => {
          refetchPrompts()
          setOpenRemoveModal(false)
        })
    }
  }

  const handleRetrieveHistory = (promptHistory: IPromptHistory) => {
    setPromptHistory(promptHistory)
    setOpenRetrieveHistoryModal(true)
  }

  return {
    changeStatus,
    handleAppClick,
    openRemoveModal,
    setOpenRemoveModal,
    openChangeStatusModal,
    setOpenChangeStatusModal,
    isUpdating,
    isLoading: isLoadingPrompt || isFetchingPrompt,
    prompt,
    handleDelete,
    isDeleting,
    setOpenHistoryModal,
    openHistoryModal,
    promptHistorises,
    isLoadingPromptHistorises,
    setOpenRetrieveHistoryModal,
    openRetrieveHistoryModal,
    promptHistory,
    handleRetrieveHistory,
    refetchPrompt,
  }
}
